// src/components/ConsentRequestsCard.jsx
// Shown at the top of the inbox for parents. Renders nothing for everyone
// else, so the inbox looks exactly the same for users with no teens linked.
import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { listenToChildren, setConsentStatus } from "../utils/consentService";
import { notificationService } from "../utils/notificationService";
import "./ConsentRequestsCard.css";

const STATUS_LABEL = {
  approved: "Approved",
  denied: "Declined",
  revoked: "Access turned off",
};

const ConsentRequestsCard = () => {
  const uid = getAuth().currentUser?.uid;
  const [teens, setTeens] = useState([]);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    if (!uid) return undefined;
    return listenToChildren(uid, setTeens, (e) =>
      console.error("Consent list failed", e)
    );
  }, [uid]);

  const act = async (teen, status, okMessage) => {
    if (busyId) return;
    setBusyId(teen.uid);
    try {
      await setConsentStatus(teen.uid, status);
      notificationService.showSuccess(okMessage);
    } catch (e) {
      console.error("Consent update failed", e);
      notificationService.showError("Couldn’t update. Try again.");
    } finally {
      setBusyId(null);
    }
  };

  const revoke = (teen) => {
    if (!window.confirm(`Turn off access for @${teen.username}?`)) return;
    act(teen, "revoked", "Access turned off.");
  };

  if (teens.length === 0) return null;

  return (
    <div className="crc-wrap">
      <h3 className="crc-heading">Parent approvals</h3>
      {teens.map((teen) => {
        const busy = busyId === teen.uid;
        return (
          <div key={teen.uid} className="crc-item">
            {teen.status === "pending" ? (
              <>
                <p className="crc-text">
                  <strong>@{teen.username}</strong> wants you to approve their
                  Trescend account. Once approved, they can use Trescend,
                  including paid features.
                </p>
                <div className="crc-actions">
                  <button
                    type="button"
                    className="crc-btn crc-primary"
                    disabled={busy}
                    onClick={() => act(teen, "approved", "Approved.")}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="crc-btn"
                    disabled={busy}
                    onClick={() => act(teen, "denied", "Request declined.")}
                  >
                    Decline
                  </button>
                </div>
              </>
            ) : (
              <div className="crc-row">
                <p className="crc-text crc-grow">
                  <strong>@{teen.username}</strong>
                  <span className="crc-status"> {STATUS_LABEL[teen.status]}</span>
                </p>
                {teen.status === "approved" ? (
                  <button
                    type="button"
                    className="crc-btn"
                    disabled={busy}
                    onClick={() => revoke(teen)}
                  >
                    Turn off access
                  </button>
                ) : (
                  <button
                    type="button"
                    className="crc-btn crc-primary"
                    disabled={busy}
                    onClick={() => act(teen, "approved", "Approved.")}
                  >
                    Approve
                  </button>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ConsentRequestsCard;